module.exports = __webpack_public_path__ + "img/sesion_btn.bd5b7d4a.png";